import{d as e}from"./chunk-73U45M5A.js";import{q as g}from"./chunk-MOWIYUQE.js";import{b as r,c as o}from"./chunk-BQNI2XMA.js";import{m as s}from"./chunk-HBP5N4FR.js";s();g();var u=()=>{let t=e(r),n=e(o);return{isPending:t,errorMessage:n}};export{u as a};
//# sourceMappingURL=chunk-LAK6OBZ7.js.map
